Shopware.Component.register('sw-cms-el-top-finder-selectboxes', () => import('./component'));
Shopware.Component.register('sw-cms-el-config-top-finder-selectboxes', () => import('./config'));
Shopware.Component.register('sw-cms-el-preview-top-finder-selectboxes', () => import('./preview'));

Shopware.Service('cmsService').registerCmsElement({
    name: 'top-finder-selectboxes',
    label: 'sw-cms-el-top-finder-selectboxes.label',
    component: 'sw-cms-el-top-finder-selectboxes',
    configComponent: 'sw-cms-el-config-top-finder-selectboxes',
    previewComponent: 'sw-cms-el-preview-top-finder-selectboxes',
    defaultConfig: {
        showSearch: {
            source: 'static',
            value: true,
        },
        showBrandSelect: {
            source: 'static',
            value: true,
        },
        showDeviceSelect: {
            source: 'static',
            value: true,
        },
        selectboxesMode: {
            source: 'static',
            value: 'both',
        },
        dropdownsColumnClass: {
            source: 'static',
            value: 'col-sm-4 col-md',
        },
    },
});
